import axios from 'axios';
import { getApiBaseUrl } from './apiHelper';

/**
 * Ensure href is absolute. If API returns /uploads/favicon.ico, prefix the API base.
 */
function toAbsoluteUrl(href) {
  if (!href) return null;
  try {
    // If already absolute, URL() won't throw
    return new URL(href).toString();
  } catch {
    // Treat as relative to API base
    const base = getApiBaseUrl();
    return `${base.replace(/\/+$/, '')}/${href.replace(/^\/+/, '')}`;
  }
}

/**
 * Remove all existing <link rel="icon"> and <link rel="shortcut icon"> and <link rel="apple-touch-icon">
 */
function removeExistingIcons() {
  const selectors = [
    'link[rel="icon"]',
    'link[rel="shortcut icon"]',
    'link[rel="apple-touch-icon"]',
    'link[rel="apple-touch-icon-precomposed"]',
    'link[rel="mask-icon"]'
  ];
  document.querySelectorAll(selectors.join(',')).forEach(n => n.parentNode.removeChild(n));
}

/**
 * Insert a <link rel="icon"> (and optional apple icon) with given href
 */
function insertIcons(href) {
  const head = document.head || document.getElementsByTagName('head')[0];

  const icon = document.createElement('link');
  icon.setAttribute('rel', 'icon');
  icon.setAttribute('href', href);
  head.appendChild(icon);

  // Optional: Apple touch icon for iOS home screen
  const apple = document.createElement('link');
  apple.setAttribute('rel', 'apple-touch-icon');
  apple.setAttribute('href', href);
  head.appendChild(apple);
}

/**
 * Update favicon using a public URL (best if your favicon is publicly accessible).
 */
export function setFaviconFromUrl(href) {
  if(!href) return; 
  const abs = toAbsoluteUrl(href);
  if (!abs) return;
  removeExistingIcons();
  insertIcons(abs);
}

/**
 * Update favicon by fetching the image as a blob (use this if the URL requires auth headers).
 */
export async function setFaviconFromProtectedUrl(href, headers = {}) {
  const abs = toAbsoluteUrl(href);
  if (!abs) return;

  const res = await axios.get(abs, { responseType: 'blob', headers, withCredentials: true });
  const blobUrl = URL.createObjectURL(res.data);

  removeExistingIcons();
  insertIcons(blobUrl);

  // Optional: clean up when you navigate away (not strictly necessary in SPA)
  // window.addEventListener('beforeunload', () => URL.revokeObjectURL(blobUrl));
}
